import { logoutAction } from 'App/actions/auth';
import { connect } from 'react-redux';
import { featuresAction as fetchFeatures } from '../../actions/features';
import { selectors as configurationSelectors } from '../../ducks/configurationDuck';
import { selectors as userSelectors } from '../../ducks/userDuck';
import Navigation from './NavigationBar';

const mapStateToProps = state => ({
  modules: configurationSelectors.modules(state) || [],
  userRoles: userSelectors.roles(state),
  organizationShortName: userSelectors.organizationShortName(state),
});

const mapDispatchToProps = {
  logout: logoutAction,
  fetchFeatures,
};

const NavigationContainer = connect(mapStateToProps, mapDispatchToProps)(Navigation);

export default NavigationContainer;
